import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSUBSCRIPTIONPLANSTableStructure";
export const UPDATE_TABLE_DATA = "updateSUBSCRIPTIONPLANSTableData";
export const EXPORT_TABLE_DATA = "exportSUBSCRIPTIONPLANSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSUBSCRIPTIONPLANSTableStructure";
export const SET_TABLE_DATA = "setSUBSCRIPTIONPLANSTableData";
export const SET_TABLE_FILTER = "setSUBSCRIPTIONPLANSTableFilter";
export const SET_TABLE_PAGE = "setSUBSCRIPTIONPLANSTablePage";
export const SET_TABLE_PER_PAGE = "setSUBSCRIPTIONPLANSTablePerPage";
export const SET_TABLE_SORT_BY = "setSUBSCRIPTIONPLANSTableSortBy";
export const SET_EXPORT_LINK = "setSUBSCRIPTIONPLANSExportLink";
export const SUB_PLAN_SET_PAGES = "setSUBSCRIPTIONPLANSPages";
export const ADD_REMOVE_PAGES_TO_SELECTED_SUB_PLAN =
  "addAndRemovePageSUBSCRIPTIONPLANS";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  all_pages: [],
  pages: [],
  // selectedLocationIndex: -1,
};

const getters = {
  getSUBSCRIPTIONPLANSTableProperties(state) {
    return state.table_structure.properties;
  },
  getSUBSCRIPTIONPLANSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSUBSCRIPTIONPLANSTableState(state) {
    return state.table_state;
  },
  getSUBSCRIPTIONPLANSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSUBSCRIPTIONPLANSTableFilters(state) {
    return state.table_structure.filters;
  },

  getSUBSCRIPTIONPLANSTableData(state) {
    return state.table_data.data;
  },

  getSUBSCRIPTIONPLANSExportUrl(state) {
    return state.export_link;
  },
  getSUBSCRIPTIONPLANSAllPages(state) {
    return state.all_pages;
  },
  getSUBSCRIPTIONPLANSPages(state) {
    return state.pages;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/subscription_plans")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/subscription_plans/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/subscription_plans/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [ADD_REMOVE_PAGES_TO_SELECTED_SUB_PLAN](state, payload) {
    const { index, selectedField, forAdding } = payload;
    // console.log(payload);
    if (forAdding) {
      state.all_pages[index].is_selected = true;
      // selectedField.is_selected = true;
      state.pages.push({
        page_name: selectedField.name,
        page_title: selectedField.title,
      });
    } else {
      const foundIndex = state.pages.findIndex(
        (page) => page.page_title === selectedField.title
      );

      if (foundIndex > -1) {
        state.all_pages[index].is_selected = false;
        state.pages.splice(foundIndex, 1);
      }
    }
  },
  [SUB_PLAN_SET_PAGES](state, data) {
    state.all_pages = data.all_pages.map((item) => ({
      ...item,
      // is_selected: false,
      is_selected: Boolean(
        data.pages.find((page) => item.title === page.page_title)
      ),
    }));

    // data.pages.map((page) => {
    //   state.pages.push({ page_name: page.name, page_title: page.title });
    // });
    state.pages = data.pages.map((item) => ({
      page_name: item.page_name,
      page_title: item.page_title,
    }));
    // console.log(state.all_pages);
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
